module.exports = __webpack_public_path__ + "img/me.71a4768.svg";